<template>
  <div class="banner-container">
    <div class="left-info">
      <TitleShow />
      <ActionBtns />
    </div>
    <div class="right-maps">
      <img src="@/assets/images/playDetails/setupAccount/banner_map.png" alt="">
    </div>
  </div>
</template>

<script>
import TitleShow from "./titleShow";
import ActionBtns from "./actionBtns";
export default {
  components: { TitleShow, ActionBtns },
  props: {},
  data() {
    return {}
  },
  mounted() { },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>